import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { apiVersion, env } from "../../api/config";
export var envConfig = function () {
    if (env === "dev") {
        return {
            baseURL: "https://api-yuj.excellonconnect.com/".concat(apiVersion, "/"),
            CHITRA_ENDPOINT: "https://dev-superset.excellonconnect.com",
            Chitra_Subscription: "920e253e-9ec7-43d0-b37c-c52cd2a17621",
            Chitra_clientId: '692884e1-ba25-484b-9553-eb4648470868',
            Chitra_clientSecret: '61c5368f-9fc4-4ab7-9f3f-c69f53775c5e'
        };
    }
    else if (env === "qa") {
        return {
            baseURL: "https://qa-idms.excellonconnect.com/v2.0/",
            CHITRA_ENDPOINT: "https://dev-superset.excellonconnect.com",
            Chitra_Subscription: "920e253e-9ec7-43d0-b37c-c52cd2a17621",
            Chitra_clientId: '692884e1-ba25-484b-9553-eb4648470868',
            Chitra_clientSecret: '61c5368f-9fc4-4ab7-9f3f-c69f53775c5e'
        };
    }
    else if (env === "uat") {
        return {
            baseURL: "https://uat-idms.excellonconnect.com/v2.0/",
            CHITRA_ENDPOINT: "https://dev-superset.excellonconnect.com",
            Chitra_Subscription: "920e253e-9ec7-43d0-b37c-c52cd2a17621",
            Chitra_clientId: '692884e1-ba25-484b-9553-eb4648470868',
            Chitra_clientSecret: '61c5368f-9fc4-4ab7-9f3f-c69f53775c5e'
        };
    }
    else if (env === "lt") {
        return {
            baseURL: "https://lt-idms.excellonconnect.com/v2.0/",
            CHITRA_ENDPOINT: "https://lt-idms.excellonconnect.com",
            Chitra_Subscription: "920e253e-9ec7-43d0-b37c-c52cd2a17621",
            Chitra_clientId: '692884e1-ba25-484b-9553-eb4648470868',
            Chitra_clientSecret: '61c5368f-9fc4-4ab7-9f3f-c69f53775c5e'
        };
    }
    else if (env === "prod") {
        return {
            baseURL: "https://bal-idms.excellonconnect.com/v2.0/",
            CHITRA_ENDPOINT: "https://dev-superset.excellonconnect.com",
            Chitra_Subscription: "920e253e-9ec7-43d0-b37c-c52cd2a17621",
            Chitra_clientId: '692884e1-ba25-484b-9553-eb4648470868',
            Chitra_clientSecret: '61c5368f-9fc4-4ab7-9f3f-c69f53775c5e',
            WS_BASE_URL: "wss://bal-idms.excellonconnect.com/"
        };
    }
    else {
        return {
            baseURL: "https://api-qa-yuj.excellonconnect.com/".concat(apiVersion, "/"),
            CHITRA_ENDPOINT: "https://dev-superset.excellonconnect.com",
            Chitra_Subscription: "920e253e-9ec7-43d0-b37c-c52cd2a17621",
            Chitra_clientId: '692884e1-ba25-484b-9553-eb4648470868',
            Chitra_clientSecret: '61c5368f-9fc4-4ab7-9f3f-c69f53775c5e'
        };
    }
};
export var Config = _objectSpread({}, envConfig());
